export type SettingsTabId =
  | "display"
  | "catalog"
  | "thread"
  | "ng"
  | "fav"
  | "other";

export type SettingsTabDefinition = Readonly<{
  id: SettingsTabId;
  label: string;
}>;

/** SP・PC共通。総合カタログの板設定はフィルタ内で扱う。 */
export const SETTINGS_TABS: readonly SettingsTabDefinition[] = Object.freeze([
  Object.freeze({ id: "display" as const, label: "全体" }),
  Object.freeze({ id: "catalog" as const, label: "カタログ" }),
  Object.freeze({ id: "thread" as const, label: "スレッド" }),
  Object.freeze({ id: "ng" as const, label: "NG設定" }),
  Object.freeze({ id: "fav" as const, label: "お気に入り" }),
  Object.freeze({ id: "other" as const, label: "読み上げ" }),
]);
